/* custom code start */
if (!customElements.get("as-seen-in-slider")) {
  class AsSeenInSlider extends HTMLElement {
    constructor() {
      super();

      this.sliderEl = this.querySelector(".swiper");
      const options = JSON.parse(this.getAttribute("data-swiper-options") || "{}");

      const prefersReducedMotion = window.matchMedia(
        "(prefers-reduced-motion: reduce)"
      ).matches;

      this.spaceBetween = options.spaceBetween ?? 12;
      this.speed = options.autoplaySpeed || 7000;
      // Marquee is only wanted when the merchant enabled autoplay AND motion is allowed.
      // Whether it actually runs is decided at runtime by overflow (see setup()).
      this.wantMarquee = Boolean(options.autoplay) && !prefersReducedMotion;
      this._marqueeMode = null;
    }

    connectedCallback() {
      this.setup();
      // Re-evaluate once images have loaded (their widths decide overflow) and on resize.
      this._onLoad = () => this.setup();
      window.addEventListener("load", this._onLoad);
      this._onResize = debounce(() => this.setup(), 200);
      window.addEventListener("resize", this._onResize);

      if (Shopify.designMode) {
        window.addEventListener("shopify:section:load", this._onLoad);
      }
    }

    disconnectedCallback() {
      if (this.swiper) this.swiper.destroy(true, true);
      window.removeEventListener("load", this._onLoad);
      window.removeEventListener("resize", this._onResize);
      if (Shopify.designMode) {
        window.removeEventListener("shopify:section:load", this._onLoad);
      }
    }

    // Do the logos fit the container? If so, center them; if they overflow, marquee.
    contentFits() {
      if (!this.sliderEl) return true;
      const slides = [
        ...this.sliderEl.querySelectorAll(
          ".swiper-slide:not(.swiper-slide-duplicate)"
        )
      ];
      if (!slides.length) return true;
      const total =
        slides.reduce((sum, s) => sum + s.getBoundingClientRect().width, 0) +
        this.spaceBetween * (slides.length - 1);
      return total <= this.sliderEl.clientWidth + 1;
    }

    setup() {
      if (!this.sliderEl) return;

      const marquee = this.wantMarquee && !this.contentFits();
      // Skip re-init when the mode hasn't changed.
      if (this.swiper && this._marqueeMode === marquee) return;
      this._marqueeMode = marquee;

      if (this.swiper) this.swiper.destroy(true, true);

      const opts = {
        slidesPerView: "auto",
        spaceBetween: this.spaceBetween,
        watchOverflow: true,
        grabCursor: true,
        a11y: false,
        on: {
          afterInit: () => {
            if (this.sliderEl) this.sliderEl.removeAttribute("style");
          }
        }
      };

      if (marquee) {
        this.sliderEl.classList.add("as-seen-in--marquee");
        opts.loop = true;
        opts.speed = this.speed;
        opts.autoplay = {
          delay: 0,
          disableOnInteraction: false,
          pauseOnMouseEnter: true
        };
      } else {
        // Logos fit (or motion reduced): a static row, centered in the container.
        this.sliderEl.classList.remove("as-seen-in--marquee");
        opts.centerInsufficientSlides = true;
      }

      this.swiper = new Swiper(this.sliderEl, opts);
    }
  }

  customElements.define("as-seen-in-slider", AsSeenInSlider);
}
/* custom code end */
